export default "__VITE_ASSET__BBMuTTDt__"